module.exports = __webpack_public_path__ + "static/img/ic_os_kex_new.6b7bb452.svg";